import type { ReactNode } from 'react';

/**
 * Um par rótulo + valor dentro de um `<dl>` — a linha de uma ficha.
 *
 * Existia em quatro telas (associado, solicitação, demanda, mesa), três delas
 * idênticas caractere por caractere e a quarta com o rótulo ao lado em vez de
 * em cima. Não foi descuido: o lint de fronteira derruba o import do módulo
 * vizinho, e a saída fácil é copiar. A saída certa é esta pasta — o que duas
 * telas precisam e não é da marca mora em `components/`.
 *
 * `inline` é a variante da mesa de cobrança: cartão estreito, rótulo curto ao
 * lado do valor, sem versalete.
 */
export function Row({
  label,
  children,
  inline = false,
}: {
  label: string;
  children: ReactNode;
  inline?: boolean;
}) {
  if (inline) {
    return (
      <div className="flex gap-2">
        <dt className="shrink-0 text-texto-suave">{label}</dt>
        <dd className="min-w-0">{children}</dd>
      </div>
    );
  }
  return (
    <div>
      <dt className="rotulo text-texto-suave">{label}</dt>
      <dd className="mt-0.5">{children}</dd>
    </div>
  );
}
